import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Modal, ModalController, NavController, ToastController} from 'ionic-angular';
import {ImageSliderComponent} from '../../../shared/components/image/slider';
import {WindowService} from '../../../shared/services/window';
import {ImageListEntity} from '../../entities/image-list.entity';
import {AbstractListComponent} from '../abstract/abstract-list.component';
import {ImageListService} from './services/image-list.service';

/**
 * Defines a template for the image listing component
 * @class
 * @extends AbstractListComponent
 */
@Component({
  selector: 'advtech-image-list',
  templateUrl: './image-list.component.html',
})
export class ImageListComponent extends AbstractListComponent {
  /**
   * Modal instance created by the ModalController
   */
  modal: Modal;

  /**
   * Emit an event telling the ImageListingModal a hero image was chosen
   * @type {EventEmitter<any>}
   */
  @Output()
  onImageSelect: EventEmitter<any> = new EventEmitter();

  /**
   * Should show the select button
   * @type {boolean}
   */
  @Input()
  showSelect: boolean = false;

  /** @inheritdoc */
  constructor(protected service: ImageListService,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public toast: ToastController,
    public windowService: WindowService) {
    super(service, navCtrl, modalCtrl, toast, windowService);
  }

  /**
   * Shows the slider modal
   * @param {number} index index in the items list
   * @returns {Promise<any>}
   */
  showSlider(index: number): Promise<any> {
    this.modal = this.modalCtrl.create(ImageSliderComponent, {images: this.items, index, showSelect: this.showSelect}, {
      cssClass: 'image-preview-modal',
      enableBackdropDismiss: true,
      showBackdrop: true,
    });

    this.modal.onDidDismiss((val) => this.hModalDismiss(val));

    return this.modal.present();
  }

  /**
   * Handles the modal dismissOnPageChange
   * @param  {ImageListEntity} val
   * @return {void}
   */
  hModalDismiss(val: ImageListEntity) {
    if (this.showSelect && val) {
      this.selectImage(val);
    }
    else if (val && val.type === 'Image') {
      this.doEditPage(val);
    }
  }

  /**
   * When an image has been selected, send it to the ImageListingModal
   * @param {Object} image
   * @returns {void}
   */
  selectImage(image: ImageListEntity) {
    this.onImageSelect.emit(image);
  }
}



// WEBPACK FOOTER //
// ./src/app/list/components/image-list/image-list.component.ts